export default __webpack_public_path__ + "static/code-sample-bfb4aa0351673c7f3975eea38e20e314.svg";